var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 47,
    viewBox: "0 0 51 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 44.4L15.8 43.4C16.8 41.6 20.6 35.1 26.6 29.3C34.9 21.1 43.3 17.3 48.9 15.6L49.5 17.5C44.1 19.1 36 22.7 28 30.7C23.3 35.2 19.5 40.7 17.5 44.4Z",
    fill: "#50AE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9 45.4L28 45C28.4 42.7 29.9 36.7999 33.9 31.1C38.7 24.2 45.7 20.4 49.4 18.7L50.2 20.5C46.7 22.1 40.1 25.6 35.6 32.2C31.7 37.6 30.3 43.2 29.9 45.4Z",
    fill: "#50AE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7 39.2999C40.6 37.2999 40.8 34.0999 41.7 31.2999C43.3 26.4999 47 23.2 49.1 21.7L50.3 23.2999C48.4 24.6999 45.1 27.5999 43.6 31.9C42.5 35.0999 42.7 38.4999 42.7 39.0999L40.7 39.2999Z",
    fill: "#50AE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 46.5C11.4 46.5 0 35.1 0 21.1C0 18.3 0.4 15.6 1.3 13L1.5 12.4H2.2C4.9 12.3 19.1 12 30.9 18.8C37.4 15.7 43.6 14.7 49.3 15.7L49.9 15.8L50.1 16.4C50.1 16.5 50.7 18.4 50.7 21.3C50.7 35.1 39.3 46.5 25.3 46.5ZM9.7 38.5C13.8 42.2 19.3 44.5 25.3 44.5C38.2 44.5 48.6 34 48.6 21.2C48.6 19.5 48.4 18.2 48.3 17.5C41 16.4 32.6 19 24 25.1C16.7 30.2 11.7 36 9.7 38.5ZM3 14.3C2.3 16.5 2 18.8 2 21.1C2 27.2 4.4 32.8 8.3 37C12.2 32.2 17.6 27.2 22.9 23.4C24.9 22 26.8 20.8 28.8 19.7C18.5 14.4 6.7 14.2 3 14.3Z",
    fill: "#50AE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4 23.5C17.2 18.6 5.4 19.5 1.5 19.8H1L0.9 17.8H1.4C5.4 17.5 17.7 16.6 26.4 21.8L25.4 23.5Z",
    fill: "#50AE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8 26.8L1.2 24.9C4.3 23.9 9 22.8 13.8 23.1C16.7 23.3 19.8 24 21.9 24.6L21.3 26.5C19.3 25.9 16.3 25.2 13.6 25.1C9.2 24.9 4.7 25.9 1.8 26.8Z",
    fill: "#50AE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9 34.3L3.8 32.5999C4.9 31.8999 7.7 30.2 10.2 29.4C12.4 28.7 14.7 28.4 16.9 28.5L16.8 30.5C14.8 30.4 12.8 30.7 10.8 31.3C8.5 32 5.9 33.6 4.9 34.3Z",
    fill: "#50AE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7 16.2H37.7V10.1H31.7V4.1L27.5 2.2L23.2 4.1V16.2H21.2V2.8L27.5 0L33.7 2.8V8.1H39.7V16.2Z",
    fill: "#50AE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0209 0.160548L19.8233 3.41614L20.6475 5.23834L27.8451 1.98275L27.0209 0.160548Z",
    fill: "#50AE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9166 0.181752L27.0924 2.00415L34.2909 5.25974L35.115 3.43734L27.9166 0.181752Z",
    fill: "#50AE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 5.69995H26.5V8.19995H28.5V5.69995Z",
    fill: "#50AE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 10.6H26.5V13.2H28.5V10.6Z",
    fill: "#50AE2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.7,
    height: 46.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.3b326fdb97e7335c893be9377e5833b1.svg";
export { ForwardRef as ReactComponent };